// extracted by mini-css-extract-plugin
export default {"container":"viewClient_container__+tKfQ","content":"viewClient_content__hV-o9"};